export default "__VITE_ASSET__Bidll5OW__"